import type { User } from '@/api/custom/auth/model'
import { UserRole, type RoutePermission } from '@/types/auth'

export function hasRole(user: User | null, requiredRoles: UserRole[]): boolean {
  if (!user || !user.role) return false
  return requiredRoles.includes(user.role as UserRole)
}

export function hasPermission(user: User | null, permission: RoutePermission): boolean {
  if (permission.roles && permission.roles.length > 0) {
    return hasRole(user, permission.roles)
  }

  return true
}

export function canAccessRoute(user: User | null, routeMeta: any): boolean {
  const permission: RoutePermission = {
    roles: routeMeta.roles,
  }

  return hasPermission(user, permission)
}
